import { render, staticRenderFns } from "./DeleteTreatmentModal.vue?vue&type=template&id=47e8f66e&scoped=true"
import script from "./DeleteTreatmentModal.vue?vue&type=script&lang=js"
export * from "./DeleteTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTreatmentModal.vue?vue&type=style&index=0&id=47e8f66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e8f66e",
  null
  
)

export default component.exports